// src/redux/dataSlice.js
import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import { parseCSV } from '../utils/csvParser';
import { CSV_URLS } from '../config/csvConfig';

export const fetchResources = createAsyncThunk(
  'resources/fetchResources',
  async (language = 'es') => {
    const url = CSV_URLS[language];
    if (!url) {
      throw new Error(`No CSV URL found for language: ${language}`);
    }
    const data = await parseCSV(url);
    return { language, data };
  }
);

const createLanguageState = () => ({
  items: [],
  status: 'idle',
  error: null,
});

const resourcesSlice = createSlice({
  name: 'resources',
  initialState: {
    es: createLanguageState(),
    en: createLanguageState(),
    pt: createLanguageState(),
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchResources.pending, (state, action) => {
        const language = action.meta.arg || 'es';
        state[language].status = 'loading';
      })
      .addCase(fetchResources.fulfilled, (state, action) => {
        const { language, data } = action.payload;
        state[language].status = 'succeeded';
        state[language].items = data;
        state[language].error = null;
      })
      .addCase(fetchResources.rejected, (state, action) => {
        const language = action.meta.arg || 'es';
        state[language].status = 'failed';
        state[language].error = action.error.message;
      });
  },
});

export default resourcesSlice.reducer;